import React from 'react'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import type { RouteConfig } from 'react-router-config'
import { OwInstock } from '@yy/one-icon'
import { withRedirect } from '@/components/Authorization'

const routes: RouteConfig[] = [
  {
    name: 'stock',
    path: '/stock',
    menuTitle: 'common.router.stock',
    component: withRedirect(Blank),
    icon: <OwInstock />,
    authCode: 'stocks',
    routes: [
      /** 库存管理 */
      {
        menuTitle: 'stock.index.title',
        path: 'list',
        component: withAsync(() => import(/* webpackChunkName: "stock" */ '@/containers/Stock/Index')),
        exact: true,
        authCode: 'stocks:management',
      },
      /** 库存详情 */
      {
        path: 'detail',
        component: withAsync(() => import(/* webpackChunkName: "stock" */ '@/containers/Stock/Detail')),
        exact: true,
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '库存详情',
        hideInMenu: true,
        parentKeys: ['/stock/list'],
      },
      {
        path: 'adjust',
        component: withAsync(() => import(/* webpackChunkName: "stock" */ '@/containers/Stock/Adjust')),
        exact: true,
      },
      // 库存同步日志
      {
        menuTitle: 'sync.inventory.record',
        parentKeys: ['/stock'],
        component: withAsync(() => import('@/containers/Stock/PlatformInventoryLog')),
        path: 'platformInventoryLog',
        exact: true,
        hideInMenu: true,
      },
      // 手动同步库存记录
      {
        menuTitle: 'sync.stock.title',
        parentKeys: ['/stock'],
        component: withAsync(() => import('@/containers/Stock/Sync')),
        path: 'sync',
        exact: true,
        hideInMenu: true,
      },
    ],
  },
]

export default routes
